/* -------------------------------------------------------------------------------------------------
 * IGoogleSSOModel
 * -----------------------------------------------------------------------------------------------*/

export interface IGoogleSSOModel {
    _id: string;
    ssoId: string;
    user: string;
}

/* -------------------------------------------------------------------------------------------------
 * GoogleSSOModel
 * -----------------------------------------------------------------------------------------------*/
export class GoogleSSOModel {
    _id: string;
    ssoId: string;
    user: string;

    constructor(data: Partial<IGoogleSSOModel>) {
        this._id = data._id ?? '';
        this.ssoId = data.ssoId;
        this.user = data.user ?? '';
    }

    static fromObject(data: Partial<IGoogleSSOModel>): GoogleSSOModel {
        const model = new GoogleSSOModel(data);

        return model;
    }

    static fromObjectList(data: Partial<IGoogleSSOModel>[]): GoogleSSOModel[] {
        return data.map((row) => GoogleSSOModel.fromObject(row));
    }

    static cloneFrom(data: Partial<IGoogleSSOModel>): GoogleSSOModel {
        const model = new GoogleSSOModel(data);

        return model;
    }

    toObject(): IGoogleSSOModel {
        const data: IGoogleSSOModel = {
            _id: this._id,
            ssoId: this.ssoId,
            user: this.user,
        };

        return data;
    }
}
